module.exports = __webpack_public_path__ + "static/media/logo-dark.4f627296.svg";